import { useQueries as useReactQueries } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";

export const useQueries = ({
  queries = [{ key: "data", queryKey: ["data"], queryFn: () => {} }],
  combine,
}) => {
  const dispatch = useDispatch();

  const handleError = (error) => {
    dispatch(
      toast({
        type: "error",
        body: parseErrorMessage(error),
      })
    );
  };

  const queriesWithErrorHandling = queries.map((query) => ({
    ...query,
    throwOnError: (error) => {
      handleError(error);
      if (query.onError) query.onError(error);
    },
  }));

  const config = {
    queries: queriesWithErrorHandling,
    combine,
  };

  const result = useReactQueries(config);

  return result;
};
